/**
 * risktypereducer.js
 * Created by calhosh on 11/6/2019.
 */

import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function getTypes(state = initialstate.riskTypes, action) {
	switch (action.type) {
		case types.GET_RISK_TYPES:
			return action.response || state;
		default:
			return state;
	}
}

export function formatRiskTypes(riskTypes) {
	let formattedRiskTypes = [];
	if (riskTypes && riskTypes.data && riskTypes.data.length > 0) {
		formattedRiskTypes = riskTypes.data;
	}
	return formattedRiskTypes;
}
